import { UserAnswersType } from '../../types';

export const userSegment = (userAnswers: UserAnswersType) => {
  const selectedSearchCriteriaUser = () => {
    const preferredSearchCriteriaAnswerData = userAnswers.find((answer) => answer.paramName === 'preferredSearchCriteria');
    const preferredSearchKeywordAnswerData = userAnswers.find((answer) => answer.paramName === 'preferredSearchKeyword');
    const budgetAnswerData = userAnswers.find((answer) => answer.paramName === 'budget');

    return !!(preferredSearchCriteriaAnswerData || preferredSearchKeywordAnswerData || budgetAnswerData);
  };

  return {
    selectedSearchCriteriaUser,
  };
};
